// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j0o8f"};